/*
 * navigation
 */

const { BREAKPOINT } = window.APP_CONFIG;

const nav = (() => {

	let scrollY = 0;
	let isAnchorBound = false;

	const header = document.querySelector('.js-header');
	const drawer = document.querySelector('.js-nav');
	const openBtns = document.querySelectorAll('.js-nav-open');
	const closeBtns = document.querySelectorAll('.js-nav-close');

	if (!header || !drawer) {
		console.warn('[nav] required elements not found:', {
			header: !!header,
			drawer: !!drawer
		});
		return;
	}

	const open = () => {

		scrollY = window.scrollY;

		header.classList.remove('is-close');
		header.classList.add('is-open');

		drawer.setAttribute('aria-hidden', 'false');
		setExpanded(true);

		document.body.classList.add('is-fixed');
		document.body.style.top = `-${scrollY}px`;

	};

	const close = () => {

		header.classList.remove('is-open');
		header.classList.add('is-close');

		drawer.setAttribute('aria-hidden', 'true');
		setExpanded(false);

		document.body.classList.remove('is-fixed');
		document.body.style.top = '';

		window.scrollTo(0, scrollY);
	};

	const setExpanded = (isOpen) => {
		openBtns.forEach(btn => {
			btn.setAttribute('aria-expanded', String(isOpen));
		});
	};

	const anchorHandler = function() {
		close();

		//const href = this.getAttribute('href');
		//if (!href || href === '#') return;

		//let url;
		//try {
		//	url = new URL(href, location.href);
		//} catch {
		//	return;
		//}

		//const isSameOrigin = url.origin === location.origin;
		//const isSamePath =
		//	url.pathname.replace(/\/$/, '') ===
		//	location.pathname.replace(/\/$/, '');

		//if (isSameOrigin && isSamePath && url.hash) {
		//	close();
		//}
	};

	const headerOverlayHandler = (e) => {
		if (!header.classList.contains('is-open')) return;
		if (e.target.closest('.js-nav')) return; // ドロワー内部は無視
		if (e.target.closest('.js-nav-open')) return;

		close();
	};

	const escHandler = (e) => {
		if (e.key !== 'Escape') return;
		if (!header.classList.contains('is-open')) return;

		close();
	};

	const bindAnchorClose = () => {

		if (isAnchorBound) return;

		const links = drawer.querySelectorAll('a[href^="#"]:not(.js-modal)');

		links.forEach(link => {
			link.addEventListener('click', anchorHandler);
		});

		isAnchorBound = true;
	};


	const init = () => {

		openBtns.forEach(btn => {
			btn.addEventListener('click', open);
		});

		closeBtns.forEach(btn => {
			btn.addEventListener('click', close);
		});

		bindAnchorClose();

		// overlay（header::after 用）
		header.addEventListener('click', headerOverlayHandler);

		// Esc
		document.addEventListener('keydown', escHandler);
	};

	return {
		init
	};

})();


/**
 * header fade-in on scroll
 */
const initHeaderFadeIn = () => {
	const header = document.querySelector('.l-header');
	if (!header) return;

	const getShowScrollY = () => {
		const isSP = window.innerWidth < BREAKPOINT.SP;

		if (isSP) {
			return window.innerHeight * 1; // SP: 100vh
		}

		return 300; // PC / TAB
	};

	const onScroll = () => {
		const SHOW_SCROLL_Y = getShowScrollY();

		if (window.scrollY > SHOW_SCROLL_Y) {
			header.classList.add('is-visible');
		} else {
			header.classList.remove('is-visible');
		}
	};

	// 初期判定
	onScroll();

	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onScroll, { passive: true });
};


/*
 * init timing
 */
const init = () => {
	nav.init();

	// トップページ（body.home）だけに適用
	if (document.body.classList.contains('home')) {
		initHeaderFadeIn();
	}
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
